import { get, post, put, del } from '../utils/request';
import { Student, PaginatedResponse } from '../types';

// 获取当前用户角色
function getUserRole(): string | null {
  const userInfo = localStorage.getItem('userInfo');
  if (userInfo) {
    return JSON.parse(userInfo).role;
  }
  return null;
}

// 获取学生列表
export async function getStudentList(params?: any): Promise<PaginatedResponse<Student>> {
  const role = getUserRole();
  let endpoint = '/campus/students';
  if (role === 'super_admin') {
    endpoint = '/admin/students';
  } else if (role === 'uploader') {
    endpoint = '/uploader/students';
  }
  return get<PaginatedResponse<Student>>(endpoint, params);
}

// 创建学生
export async function createStudent(data: Partial<Student>): Promise<{ id: string }> {
  const role = getUserRole();
  let endpoint = '/campus/students';
  if (role === 'super_admin') {
    endpoint = '/admin/students';
  } else if (role === 'uploader') {
    endpoint = '/uploader/students';
  }
  return post(endpoint, data);
}

// 更新学生
export async function updateStudent(id: string, data: Partial<Student>): Promise<void> {
  const role = getUserRole();
  let endpoint = `/campus/students/${id}`;
  if (role === 'super_admin') {
    endpoint = `/admin/students/${id}`;
  } else if (role === 'uploader') {
    endpoint = `/uploader/students/${id}`;
  }
  return put(endpoint, data);
}

// 删除学生
export async function deleteStudent(id: string): Promise<void> {
  const role = getUserRole();
  let endpoint = `/campus/students/${id}`;
  if (role === 'super_admin') {
    endpoint = `/admin/students/${id}`;
  } else if (role === 'uploader') {
    endpoint = `/uploader/students/${id}`;
  }
  return del(endpoint);
}

// 获取学生详情
export async function getStudentDetail(id: string): Promise<Student> {
  const role = getUserRole();
  let endpoint = `/campus/students/${id}`;
  if (role === 'super_admin') {
    endpoint = `/admin/students/${id}`;
  } else if (role === 'uploader') {
    endpoint = `/uploader/students/${id}`;
  }
  return get<Student>(endpoint);
}

// 批量导入学生
export async function importStudents(students: Partial<Student>[], campusId?: string): Promise<any> {
  const role = getUserRole();
  let endpoint = '/campus/students/import';
  if (role === 'super_admin') {
    endpoint = '/admin/students/import';
  } else if (role === 'uploader') {
    endpoint = '/uploader/students/import';
  }
  return post(endpoint, { students, campusId });
}

// 获取学生统计
export async function getStudentStatistics(): Promise<{ total: number; byCampus: Array<{ id: string; campus_name: string; count: number }> }> {
  const role = getUserRole();
  let endpoint = '/campus/students/statistics';
  if (role === 'super_admin') {
    endpoint = '/admin/students/statistics';
  } else if (role === 'uploader') {
    endpoint = '/uploader/students/statistics';
  }
  return get(endpoint);
}
